var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-compare" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "row home-form" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.dropDownClose,
                  expression: "dropDownClose"
                }
              ],
              staticClass: "btn-blck dropdown__blck"
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn  btn-big dropdown",
                  on: { click: _vm.dropDownToggle }
                },
                [_vm._v("Fixed price 1 year")]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.dropdownOpen
                  ? _c("div", { staticClass: "dropdown__el" }, [
                      _c(
                        "div",
                        { staticClass: "dropdown-list" },
                        _vm._l(5, function(num) {
                          return _c(
                            "span",
                            {
                              staticClass: "dropdown-item",
                              on: { click: _vm.dropDownToggle }
                            },
                            [
                              _vm._v(
                                "\n                                Customerservice" +
                                  _vm._s(num) +
                                  "\n                            "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 d-flex align-items-stretch" }, [
          _c("div", { staticClass: "info__blck" }, [
            _c("div", { staticClass: "form-group error " }, [
              _c(
                "label",
                {
                  staticClass: "min-min p-white",
                  on: {
                    click: function($event) {
                      return _vm.forLabelClick($event)
                    }
                  }
                },
                [_vm._v("Your postcode")]
              ),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", title: "Electricity consumption/year" },
                on: {
                  focus: function($event) {
                    return _vm.formControlFocus($event)
                  },
                  blur: function($event) {
                    return _vm.formControlBlur($event)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "error-text" }, [
              _vm._v("Please enter your address")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 d-flex align-items-stretch" }, [
          _c("div", { staticClass: "info__blck" }, [
            _c(
              "div",
              {
                staticClass: "form-group error electricity",
                class: { active: _vm.checkClass(_vm.electricity) }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "min-min p-white",
                    on: {
                      click: function($event) {
                        return _vm.forLabelClick($event)
                      }
                    }
                  },
                  [_vm._v("Electricity/year")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.electricity,
                      expression: "electricity",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    title: "Electricity consumption/year"
                  },
                  domProps: { value: _vm.electricity },
                  on: {
                    focus: function($event) {
                      return _vm.formControlFocus($event)
                    },
                    blur: [
                      function($event) {
                        return _vm.formControlBlur($event)
                      },
                      function($event) {
                        return _vm.$forceUpdate()
                      }
                    ],
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.electricity = _vm._n($event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("small", [_vm._v("kWh")])
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "error-text" }, [
              _vm._v("Please enter your address")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "range-form-item-inner" }, [
        _c("div", { staticClass: "form-data-a" }, [
          _c("div", { staticClass: "box-centered" }, [
            _c("div", { staticClass: "load-data" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sum,
                    expression: "sum"
                  }
                ],
                attrs: { type: "hidden", max: "400" },
                domProps: { value: _vm.sum },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.sum = $event.target.value
                  }
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ranges-slider__blck" },
          [
            [
              _c("range-slider", {
                staticClass: "slider",
                attrs: { min: 1000, max: 30000, step: 1000 },
                model: {
                  value: _vm.electricity,
                  callback: function($$v) {
                    _vm.electricity = $$v
                  },
                  expression: "electricity"
                }
              })
            ],
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "slider__scales2" },
              _vm._l(_vm.separators, function(separator, num) {
                return _c(
                  "div",
                  {
                    staticClass: "scale_item",
                    class: { active: null !== separator.label },
                    style: "left:" + separator.percent + "%"
                  },
                  [
                    _vm._m(3, true),
                    _vm._v(" "),
                    null !== separator.label
                      ? _c(
                          "button",
                          {
                            staticClass: "data__blck",
                            staticStyle: { left: "-20px" },
                            on: {
                              click: function($event) {
                                return _vm.setRangeValue(num)
                              }
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(separator.label))])]
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm._m(4)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "title" }, [
        _c("h1", { staticClass: "h1 p-title p-black p-center relawayBold" }, [
          _vm._v("Compare electricity providers with TecknaEl.se")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "Raleway max-max p-center" }, [
          _vm._v("Find the best option for yourself in a few clicks ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row d-lg-none mobile-block" }, [
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "head-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/header/shield.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("Elbyte med prisgaranti")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "head-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/header/scales.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("Jämför och byt gratis ")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "head-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/header/calendar.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("14 dagars ångerrätt")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contact_type" }, [
      _c("div", { staticClass: "desc" }, [
        _c("p", { staticClass: "min p-dgrey" }, [
          _vm._v("Choose contract type")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "item" }, [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-6 p-center" }, [
          _c("p", { staticClass: " med mb-0" }, [
            _vm._v("You save in average: "),
            _c("b", { staticClass: "p-green" }, [_vm._v("500 kr/year")]),
            _vm._v(" by using "),
            _c("b", { staticClass: "p-green" }, [_vm._v("TecknaEl.se")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-5" }, [
          _c("div", { staticClass: "compare-btn" }, [
            _c("button", { staticClass: "btn btn-green btn-full" }, [
              _vm._v("Compare prices")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }